// INSPECTION AUTHORITY
export const GET_INSPECTION_AUTHORITIES = '/inspection-authorities/query';
export const GET_INSPECTION_AUTHORITY = '/inspection-authorities/';
export const POST_INSPECTION_AUTHORITY = '/inspection-authorities/';
export const PUT_INSPECTION_AUTHORITY = '/inspection-authorities/';
export const DELETE_INSPECTION_AUTHORITY = '/inspection-authorities/';
export const CHECK_INSPECTION_AUTHORITY_EXISTS = '/inspection-authorities/query';
